var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatabasePlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,30a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56,23.82H8a4,4,0,0,0-4,4v8.36a4,4,0,0,0,4,4H56a4,4,0,0,0,4-4V27.82A4,4,0,0,0,56,23.82Zm0,12.36H8V27.82H56Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,12.12a2,2,0,1,1-2-2A2,2,0,0,1,16,12.12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41,8V7h6V4H8A4,4,0,0,0,4,8V16.3a4,4,0,0,0,4,4H47V17H41v-.7H8V8Zm16,9v3.18A4,4,0,0,0,60,17ZM57,4.08V7h2.92A4,4,0,0,0,57,4.08Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,50a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56,43.7H8a4,4,0,0,0-4,4V56a4,4,0,0,0,4,4H56a4,4,0,0,0,4-4V47.7A4,4,0,0,0,56,43.7ZM56,56H8V47.7H56Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41,11.38v1.5H20.12a.75.75,0,0,1,0-1.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.87,32.75H20.12a.75.75,0,0,1,0-1.5H51.87a.75.75,0,1,1,0,1.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.87,52.79H20.12a.75.75,0,1,1,0-1.5H51.87a.75.75,0,0,1,0,1.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56,16.3h0V16h0ZM56,8V8h0V8Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56,8V2H48V8H42v8h6v6h8V16h6V8ZM44,14V10h6V4h4v6h6v4H54v6H50V14Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56,16v.3h0V16Zm0-8V8h0V8Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabasePlus);
export default __webpack_public_path__ + "static/media/Database_Plus.d9a8b9ca.svg";
export { ForwardRef as ReactComponent };